import { api_GET, api_POST } from "./_api.js";

const mapeamentoArboreo_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("MapeamentoArboreo/GetList")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("MapeamentoArboreo/GetItem" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("MapeamentoArboreo/", model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default mapeamentoArboreo_api;
